import { CodeLibelle } from "./codeLibelle";

export enum EtatHoraire {
	ALL_DAYS = 0,
	CUSTOMISE = 1,
}

export enum TypeDialog {
	CONFIRMATION_WITH_MOTIF,
	DELETE_CONFIRMATION,
	EROOR_WITH_MSG,
	CONFIRMATION,
	OPENING_HOURS,
	CONFIRMATION_INSCRIPTION,
}

export enum UserRole {
	CHARGEUR = 1,
	PRESTATAIRE = 2,
	CONTROL_TOWER = 3,
}

export enum ServiceType {
	TRANSPORTEUR = 0,
	BROKER = 1,
	TRANSPORTEUR_BROKER = 2,
	CONTROL_TOWER = 3,
}

export enum UploadDirectory {
	LOGO = 1,
	COTATION_DOCS = 2,
	BULK_IMPORT = 3,
	INVOICE = 4,
}

export enum EtatRelation {
	EN_COURS = 0,
	ACTIF = 1,
	IGNORER = 2,
	ANNULER = 3,
	BLACKLIST = 4,
}

export enum StatusDemande {
	ENCOURS = 0,
	ACCPETER = 1,
	IGNORER = 2,
	ANNULER = 3,
}

export enum Modules {
	PRICING = 1,
	TRANSPORT_MANAGEMENT = 2,
	QUALITY_MANAGEMENT = 3,
	COMPLIANCE_MATRIX = 4,
	TRACK = 5,
	CLAIMS = 6,
	FREIGHT_AUDIT = 7,
	FREIGHT_ANALYTICS = 8,
	REPO_DEVISE = 9,
	ETATAQUAI = 10,
  DASHBOARD = 11,
}

export enum SavedFormIdentifier {
	SAVED_SEARCH = 1,
	PRICING_MASK = 2,
	FAVORIS = 3,
	HISTORY = 4,
}

export enum ModeTransport {
	AIR = 1,
	SEA = 2,
	ROAD = 3,
	INTEGRATOR = 4,
}

export enum TypeModal {
	INFORMATION = 0,
	CONFIRMATION = 1,
}

export enum DemandeStatus {
	IN_PROCESS = 1,
	WAITING_FOR_RECOMMENDATION = 2, // en cas de recommendation coché par le chargeur
	RECOMMENDATION = 3, // waiting for confirmation

	FINAL_CHOICE = 4, // devenu inutile
	CAN = 6, // devenu inutile

	WDCT = 10,
	WPU = 11,
	TO = 12,
	DLVRY = 13,
}

export enum CarrierStatus {
	REQUEST_RECEIVED = 1,
	QUOTE_SENT = 2,
	RECOMMENDATION = 3,
	FINAL_CHOICE = 4,
	NOT_AWARDED = 5,
}

export enum FileType {

	INVOICE = 1,
	LISTE_COLISAGE = 2,
	DOUANE = 3,
	TRANSPORT_DOCUMENT = 4,
	OTHER = 5,
	POD = 6,
}

export enum EtatUser {
	ACTIF = 1,
	DESACTIVE = 2,
	NON_ACTIF = 3,
	ACCEPTER_PAR_ADMIN = 4
}

export enum TypeDemande {
	STANDARD = 1,
	URGENT = 2
}

export enum DatatableComponent {
	PRICING = 1,
	BOOKING = 2,
	FREIGHT_AUDIT = 3,
	TRACK = 4,
	ETATAQUAI=10
}

export enum OriginCustomsBroker {
	MY_TOWER_OPERATION = 1,
	CARRIER = 2,
	NOT_APPLICABLE = 3
}

export enum InvoiceStatus {
	WAITING_FOR_CARRIER_INPUT = 1,
	WAITING_FOR_CHARGEUR_CONFIRMATION = 2,
	WAITING_FOR_CARRIER_CONFIRMATION = 3,
	CONFIRMED_BY_CHARGEUR = 4
}

export enum RoleSociete {
	CHARGEUR = 1,
	PRESTATAIRE = 2,
}

export enum AccessRights {
	CONTRIBUTION = 0,
	VISUALISATION = 1,
	NON_VISIBLE = 2,
}

export enum Late{
	LATE_TRACK = 1,
	NOT_LATE = 2
}

export enum IDChatComponent{
	FREIGHT_AUDIT = 1,
	TRANSPORT_MANAGEMENT = 2,
	TRACK = 3,
	PRICING = 4,
	REPO_DEVISE = 5

}

export enum EnumPsl {
	PICKUP = 1,
	DEPARTURE = 2,
	ARRIVAL = 3,
	DOUANE = 4,
	DELIVERY = 5
}

export enum TypeChamp{
	normal = 1,
	special = 2
};

export enum TypeCustomsBroker{
	MY_TOWER_OPERATION = 1,
	CARRIE = 2,
	NOT_APPLICABLE = 3,
}


export enum TypeFlux {
	ENTREPOT = 1,
	DOSSIER  = 2,
}


// WEBPACK FOOTER //
// ./src/app/utils/enumeration.ts